module.exports = __webpack_public_path__ + "img/sam-bucket-hat-03.884befb9.jpg";